<usb-base-item
  [item]="item"
  [styleSidebar]="styleSidebar"
  [currencyAgency]="currencyAgency"
  [currencies]="currencies"
  [clientsSettingAppBooking]="clientsSettingAppBooking"
>
  <!-- Per-leg schedule (ida / vuelta), armado con los segmentos reales que
       FlyProductService guardó en item.itinerary. No hay precio ni status
       por tramo: item es una única tarifa que cubre todo el itinerario. -->
  <ng-container *ngFor="let leg of item.itinerary; let last = last">
    <hr class="w-100 p-0 mb-3" style="border: none;" />

    <div class="d-flex flex-column detail-item" [class.mb-4]="!last">
      <div class="d-flex flex-column mb-3">
        <!-- <p
          style="
            font-family: 'Rubik';
            font-size: 15px;
            font-weight: 600;
            line-height: 1.2;
            text-transform: none;
          "
          class="m-0"
        >
          {{ getAirlineCodes(leg) }} {{ getFlightNumbers(leg) }} ({{ getDirectionLabel(leg) }})
        </p> -->
      </div>

      <!-- Route -->
      <div class="d-flex justify-content-between mb-3" style="gap: 15px;">
        <div class="d-flex flex-column w-100">
          <span
            style="
              font-family: 'Rubik';
              font-size: 13px;
              font-weight: 500;
              line-height: 1.2;
              color: #2c2c2c;
              text-transform: none;
            "
          >
            Origen: {{ getFirstSegment(leg)?.departure?.airport }}
          </span>
          <!-- <p
            style="
              font-family: 'Rubik';
              font-size: 12px;
              color: #747474;
              font-weight: 400;
              line-height: 1.2;
              margin: 0;
            "
          >
            {{ getFirstSegment(leg)?.departure?.airport }}
          </p> -->
          <span
            style="
              font-family: 'Rubik';
              font-size: 13px;
              font-weight: 600;
              line-height: 1.2;
              color: #000000;
              text-transform: none;
            "
          >
            {{ getFirstSegment(leg)?.departure?.dateTime | date: "EEE. dd MMM yyyy" : undefined : "es" }}
          </span>
          <p
            style="
              font-family: 'Rubik';
              font-size: 12px;
              color: #747474;
              font-weight: 400;
              line-height: 1.2;
              margin: 0;
            "
          >
            {{ getFirstSegment(leg)?.departure?.dateTime | date: "HH:mm" }} hs.
          </p>
        </div>

        <div class="d-flex flex-column w-100">
          <span
            style="
              font-family: 'Rubik';
              font-size: 13px;
              font-weight: 500;
              line-height: 1.2;
              color: #2c2c2c;
              text-transform: none;
            "
          >
            Destino: {{ getLastSegment(leg)?.arrival?.airport }}
          </span>
          <!-- <p
            style="
              font-family: 'Rubik';
              font-size: 12px;
              color: #747474;
              font-weight: 400;
              line-height: 1.2;
              margin: 0;
            "
          >
            {{ getLastSegment(leg)?.arrival?.airport }}
          </p> -->
          <span
            style="
              font-family: 'Rubik';
              font-size: 13px;
              font-weight: 600;
              line-height: 1.2;
              color: #000000;
              text-transform: none;
            "
          >
            {{ getLastSegment(leg)?.arrival?.dateTime | date: "EEE. dd MMM yyyy" : undefined : "es" }}
          </span>
           <p
            style="
              font-family: 'Rubik';
              font-size: 12px;
              color: #747474;
              font-weight: 400;
              line-height: 1.2;
              margin: 0;
            "
          >
          {{ getLastSegment(leg)?.arrival?.dateTime | date: "HH:mm" }} hs.
            </p>
        </div>
      </div>

      <!-- Duration / Stops -->
      <div class="d-flex align-items-center mb-3" style="gap: 15px;">
        <div class="d-flex flex-column w-100">
          <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1.2;
                color: #3e3e3e;
                text-transform: none;
              "
          >
            Tiempo de vuelo:
          </span>
          <p
            style="
              font-family: 'Rubik';
              font-size: 12px;
              color: #747474;
              font-weight: 400;
              line-height: 1.2;
              margin: 0;
            "
          >
            {{ getLegDuration(leg) }}
          </p>
        </div>
        <div class="d-flex flex-column w-100">
             <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1.2;
                color: #3e3e3e;
                text-transform: none;
              "
            >
              Tiempo de escala:
            </span>
             <p
              style="
                font-family: 'Rubik';
                font-size: 12px;
                color: #747474;
                font-weight: 400;
                line-height: 1.2;
                margin: 0;
              "
            >
               {{ getStopsLabel(leg) }}
            </p>
        </div>



      </div>

      <div class="d-flex align-items-center mb-3" style="gap: 15px;">
        <div class="d-flex flex-column w-100">
          <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1.2;
                color: #3e3e3e;
                text-transform: none;
              "
          >
            Cabina:
          </span>
          <p
            style="
              font-family: 'Rubik';
              font-size: 12px;
              color: #747474;
              font-weight: 400;
              line-height: 1.2;
              margin: 0;
            "
          >
            {{ getLegDuration(leg) }}
          </p>
        </div>
        <div class="d-flex flex-column w-100">
             <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1.2;
                color: #3e3e3e;
                text-transform: none;
              "
            >
             Nro de vuelo:
            </span>
             <p
              style="
                font-family: 'Rubik';
                font-size: 12px;
                color: #747474;
                font-weight: 400;
                line-height: 1.2;
                margin: 0;
              "
            >
               {{ getStopsLabel(leg) }}
            </p>
        </div>



      </div>

    </div>
  </ng-container>

  <!-- Passengers -->
  <!-- <hr class="w-100 p-0 mb-3" style="border: none; border-top: 2px solid #000000;" /> -->
  <!-- <div class="d-flex align-items-center mb-3" style="gap: 10px;">
    <div class="d-flex align-items-center" style="gap: 2px;">
      <img width="18" height="18" src="../../../../../../assets/icons/itinerary/persona.svg"/>
      <span style="font-size: 13px; font-weight: 600; font-family: 'Rubik'; text-transform: none;">
        {{ item?.adults }} {{ item?.adults === 1 ? 'Adulto' : 'Adultos' }}
      </span>
    </div>

    <div *ngIf="item?.children" class="d-flex align-items-center" style="gap: 2px;">
      <img width="18" height="18" src="../../../../../../assets/icons/search-result/hotel/NIÑO.svg"/>
      <span style="font-size: 13px; font-weight: 600; font-family: 'Rubik'; text-transform: none;">
        {{ item?.children }} {{ item?.children === 1 ? 'Niño' : 'Niños' }}
      </span>
    </div>
  </div> -->
</usb-base-item>
